import React from "react";
import { Updater } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import {
  ChannelType,
  ConversionStageReachedType,
  DeviceType,
  StatSigViewType,
  UserBehaviorFilterType,
  VisitorType,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { ConversionStageReachedFilter } from "@src/features/analytics/analyticsFilters/ConversionStageReachedFilter";
import { UserBehaviorViewsFilter } from "@src/features/analytics/analyticsFilters/UserBehaviorViewsFilter";

import { IExperienceDashboardFilters } from "../../../store/types/dashboardFilters";

interface UserBehaviorFilter2Props {
  userBehavior: UserBehaviorFilterType;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
  onStringFilterChange: (
    newValue:
      | DeviceType
      | VisitorType
      | ChannelType
      | StatSigViewType
      | ConversionStageReachedType,
    filterKey:
      | "statSigView"
      | "deviceType"
      | "channelType"
      | "visitorType"
      | "reachedCheckoutStage"
  ) => void;
  conversionStageReached: ConversionStageReachedType;
}
export const UserBehaviorFilter = ({
  setDialogFilters,
  userBehavior,
  onStringFilterChange,
  conversionStageReached,
}: UserBehaviorFilter2Props) => {
  return (
    <Grid container direction={"column"} rowSpacing={2}>
      <Grid item container direction={"column"} rowSpacing={1}>
        <Grid item>
          <IgTypography fontWeight={"fontWeightMedium"}>
            Conversion Funnel
          </IgTypography>
        </Grid>
        <Grid item>
          <ConversionStageReachedFilter
            conversionStageReached={conversionStageReached}
            onStringFilterChange={onStringFilterChange}
          />
        </Grid>
      </Grid>
      <Grid item container direction={"column"} rowSpacing={0.4}>
        <Grid item>
          <IgTypography fontWeight={"fontWeightMedium"}>Views</IgTypography>
        </Grid>
        <Grid item>
          <UserBehaviorViewsFilter
            userBehavior={userBehavior}
            setDialogFilters={setDialogFilters}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
